/* eslint-disable spaced-comment */
import { API_INSTANCE } from "../api/api";
import enWw from "./en-WW.json";

// eslint-disable-next-line spaced-comment
//import frFr from "./fr-FR.json";

let traductions = enWw;

export function setTraduction(fileTraductions) {
  traductions = Object.assign(traductions, fileTraductions);
}

/**
 * Use this function in case what we recieve for translation is xml.
 */
// function getJsonFromXml() {
//   let xmlDoc;

//   if (typeof window.DOMParser !== "undefined") {
//     const xmlhttp = new XMLHttpRequest();
//     xmlhttp.open(
//       "GET",
//       "file:///E:/Projets/motion-sizer/src/utils/translation/en-WW.xml"
//     ); // `${language}.xml`, true);
//     xmlhttp.onreadystatechange = () => {
//       xmlDoc = xmlhttp.responseXML;
//       console.log(xmlDoc === null);
//     };
//     xmlhttp.send();
//   }

//   const jsonOutput = {};
//   const xmlElements = xmlDoc.getElementsByTagName("settings");
//   Array.prototype.forEach.call(xmlElements, (element) => {
//     console.log(element);
//     jsonOutput[element.childNodes[0].nodeValue] =
//       element.childNodes[1].nodeValue;
//   });

//   return jsonOutput;
// }
export const loadTranslation = async (locale) => {
  const lang = locale.toLowerCase();
  const labels = enWw;
  let countryFileData;
  let defaultTranslationFileData;
  await Promise.all([
    API_INSTANCE.get(`${process.env.REACT_APP_TRANSLATION_URL}/translations/locale_${lang.replace("-", "_")}.json`)
      .then((payload) => {
        countryFileData = payload.data;
      })
      .catch(() => {}),
    API_INSTANCE.get(`${process.env.REACT_APP_TRANSLATION_URL}/translations/default-translation.json`)
      .then((payload) => {
        defaultTranslationFileData = payload.data;
      })
      .catch(() => {})
  ]);
  if (defaultTranslationFileData) {
    Object.assign(labels, defaultTranslationFileData);
  }
  if (countryFileData) {
    Object.assign(labels, countryFileData);
  }
  // console.log(labels);
  setTraduction(labels);
};

export function tr(key, data) {
  // console.log(key, data);
  const label = t(key);
  if (!label || !Object.keys(data).length) {
    return label;
  }
  const regex = /\$?\{([^}]*?)\}/g;
  return label.replace(regex, (match, token) => {
    return data[token] !== undefined ? data[token] : match;
  });
}

export default function t(key) {
  return traductions[key] || key;
}
